import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";

import {DirectoryItemModel} from "../../models/directory-item.model";
import {DirectorySearchTabConfigModel} from "../../models/directory-search-tab-config.model";
import moment, {Moment} from "moment";

declare function externalAddToBookletFn(title: string, url: string, eventId: string): any;
declare function externalIsInBookletFn(url: string): boolean;

@Component({
    selector: "pcg-ng-directory-item",
    template: require('./directory-item.component.html')
})
export class DirectoryItemComponent implements OnInit {
    public DATE_FORMAT = "dddd Do MMMM YYYY";
    public MAX_OCCURRENCES_COUNT = 10;

    @Input() public itemToDisplay: DirectoryItemModel;
    @Input() public searchTabConfig: DirectorySearchTabConfigModel;

    public nearestOccurrence: Moment;
    public startTime: Moment;
    public endTime: Moment;

    public showDatesList: boolean = false;
    public otherOccurrences: Array<Moment> = [];

    @ViewChild("addToBookletButton", { read: ElementRef, static: false }) private addToBookletButtonRef: ElementRef;

    public ngOnInit(): void {
        this.parseOccurrences();
    }

    public onAddToBookletButtonClicked(e: Event): void {
        e.preventDefault();

        if (!this.isInBooklet) {
            externalAddToBookletFn(this.itemToDisplay.name, this.getDetailsPageUrl(false), this.itemToDisplay.id);
        }
    }

    public getDetailsPageUrl(includeReturnUrl: boolean = true): string {
        return `${this.searchTabConfig.viewPageUrl}?id=${this.itemToDisplay.id}` + (this.nearestOccurrence ? `&date=${this.nearestOccurrence.format("DD/MM/YYYY")}` : "") + (includeReturnUrl ? `&returnUrl=${encodeURIComponent(window.location.href)}` : "");
    }

    public get isInBooklet(): boolean {
        return externalIsInBookletFn(this.getDetailsPageUrl(false));
    }

    private parseOccurrences(): void {
        this.nearestOccurrence = this.itemToDisplay.occurrenceDate;

        if (this.itemToDisplay.startTime && this.itemToDisplay.endTime) {
            this.startTime = moment.utc().startOf("day").add(this.itemToDisplay.startTime, "minutes");
            this.endTime = moment.utc().startOf("day").add(this.itemToDisplay.endTime, "minutes");
        }

        if (!this.itemToDisplay?.occurrences?.length) {
            return;
        }

        const futureDates = this.itemToDisplay.occurrences
            .map(value => moment(value))
            .filter(date => date.isValid())
            .filter(date => (date.diff(this.nearestOccurrence) > 0))
            .slice(0, this.MAX_OCCURRENCES_COUNT);

        if (!futureDates.length) {
            return;
        }

        this.otherOccurrences.push(...futureDates);
    }

    public toggleDatesList(): void {
        this.showDatesList = !this.showDatesList;
    }
}
